import { useAuth } from 'react-oidc-context';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

export const AXIOS_INSTANCE = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const useCustomAxios = <T>() => {
    const auth = useAuth();

    const customAxios = async (config: AxiosRequestConfig): Promise<T> => {
        const accessToken = auth.user?.access_token;
        const { data } = await AXIOS_INSTANCE({
            ...config,
            headers: {
                ...config.headers,
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    };
    return customAxios;
};

export type ErrorType<Error> = AxiosError<Error>;
